import { Component, OnInit } from '@angular/core';
import { StrAdmnCommissionFilterModel } from '../../models/store';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { StoreService } from '../../services/store.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { GetStoreAdminCommissionListInterface } from '@app/feature/store-admin/services/GetStoreAdminCommissionList.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'app-store-admin-commission-list',
  templateUrl: './store-admin-commission-list.component.html',
  styleUrls: ['./store-admin-commission-list.component.css']
})
export class StoreAdminCommissionListComponent implements OnInit {

  filterModel !: StrAdmnCommissionFilterModel;
  commissionList !: GetStoreAdminCommissionListInterface[];
  // For Infinite scroll of grid
  pageSize = 10; // No of items to load from server side i.e no of items to take
  initialItemsCount = 0;  // No of items to skip
  searchCommission: FormGroup;
  // To show hide 'No record div'
  isDisplay = true;
  isFullListDisplayed: boolean = false;
  IsPayPalConfig: boolean = false;
  // ---------------------------
  constructor(private loader: LoaderService,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
    private storeService: StoreService,
    private errorhandlerService: ErrorhandlerService,
    private router: Router) {
    this.searchCommission = this.formBuilder.group({
      search: [''],
      status : ['']
    });
  }

  ngOnInit() {
    this.fn_Initialize();
    this.fn_GetCommissionList(false);
  }

  fn_Initialize() {
    this.initialItemsCount = 0;
    this.commissionList = [];
    this.filterModel = {
      Skip: this.initialItemsCount,
      Take: this.pageSize,
      searchBy: '',
      status: '',
      UserId: localStorage.getItem('userId')
    };
  }

  /** Func to get commission list
  * isScroll: TRUE means func is called from INFINITE scolling in html
  */
  fn_GetCommissionList(isScroll: boolean) {
    if (!isScroll) {
      this.loader.show();
      this.initialItemsCount = 0;
      this.commissionList = []
    } else {
      this.loader.hide();
      this.loader.lazyLoaderShow();
    }
    this.filterModel.Skip = this.initialItemsCount;
    this.storeService.GetStoreAdminCommissionList(this.filterModel).subscribe((res) => {
      if (res.StatusCode === 200) {
        this.fn_AddLazyLoadedItems(res.Data.ResponseData);
        this.loader.lazyLoaderHide();
        this.loader.hide();
      } else if (res.StatusCode === 204 || res.StatusCode === 404) {
        if (this.initialItemsCount <= 0) {
          this.notificationService.error(res.Message, 'Record(s)');
        }
        this.loader.lazyLoaderHide();
        this.loader.hide();
      }
    }, (err: any) => {
      this.loader.lazyLoaderHide();
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  /** Func to search by store name or order no */
  fn_searchCommission(form: FormGroup) {
    this.commissionList = [];
    this.initialItemsCount = 0;
    this.filterModel.searchBy = form.controls['search'].value;
    this.filterModel.status = form.controls['status'].value;
    this.fn_GetCommissionList(false);
  }

  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems(items: GetStoreAdminCommissionListInterface[]) {

    //this.commissionList = this.commissionList.concat(items);
    //this.initialItemsCount = this.commissionList.length;

    if (items !== null && items.length !== 0) {
      for (let i = 0; i < items.length; i++) {
        if (!this.commissionList.find(x => x.OrderId === items[i].OrderId)) {
          this.initialItemsCount = this.commissionList.push(items[i]);
        }

      }
    }
    this.IsPayPalConfig = this.commissionList.length > 0 ? this.commissionList[0].IsPayPalConfig : false;
    if (items.length < this.pageSize) {
      this.isFullListDisplayed = true;
    }
    this.isDisplay = this.initialItemsCount === 0;
  }
  fn_RedirectToOrderDetail(orderNo: string) {
    this.router.navigate(['/store/orderdetail', orderNo]);
  }
}
